import $ from 'jquery';
import {H2GRESULTS,getRouteringTestResults} from 'h2g-test-results/js/test-results';
import {is_ios,TUTIL,sendAnalyticsInfo,applyFix,software_use_events} from 'h2g-test-results/js/util';
import H2GDIALOG from 'h2g-material/dialogs/h2g-dialog';

angular.module('WTG.SPECTRUM', ['WTG.DIALOG','WTG.RESULTS'])
.factory('WTGSPECTRUM',function($rootScope,WTGDIALOG,TESTRESULTS) {
 var wifi_spectrum = {
  root_path : C11N.root_path +"wifi-spectrum/templates/",
  getRSSIFromRSS : function getRSSIFromRSS(rss) {
   // assuming that the range of signal strength is in between -100dbm to -10dbm
   // took this range from msdn : https://msdn.microsoft.com/en-us/library/windows/desktop/ms706749(v=vs.85).aspx
   return ((rss <= -100) ? 0 : ((rss >= -30) ? 100 : (1.3 * (rss + 100))));
  },
  fitCanvasToContainer : function fitCanvasToContainer(id){
   var canvas = document.getElementById(id);
   canvas.style.width='100%';
   canvas.style.height='100%';
   canvas.width = canvas.offsetWidth;
   canvas.height = canvas.offsetHeight;
  },
  goBackToOneView : function() {
   if(!C11N.is_portal) $rootScope.goBackToOneView();
  },
  goBackToTwoViews : function() {
   if(!C11N.is_portal) $rootScope.goBackToTwoViews();
  },
  validateRouter : function validateRouter(scope,res_json,screen_open){
   var routering_res = getRouteringTestResults();
   var error_msg;
   if(routering_res && routering_res.res_data && routering_res.res_data.type && routering_res.result && (routering_res.result == "ok")){
    if(screen_open) {
     if(routering_res.res_data.channels) {
      if(!C11N.is_portal) return ShowScreen("#/app/WifiSpectrumManual");
      return H2GRESULTS.showManualSelectionPage();
     }
     
      error_msg = $rootScope.strings.wifi_help_router_not_configured;
     
    }
    else{
     WTGDIALOG.open_simple_dialog(WTGDIALOG.gen_popup, { header: $rootScope.strings.wifi_spectrum_btn_switch_channel ,
     body: $rootScope.strings.id_switch_channel_confimation_desc, btn_two:$rootScope.strings.cancel_btn, btn_one: $rootScope.strings.ok_btn,
     cb_one: function(){
      var opt_results = TESTRESULTS.getWifiOptimizerTestResults();
      var band = Object.keys(res_json).map(function(x){ return x});
      var sCurrentScreen = window.location.href;
      if(sCurrentScreen.search("WifiSpectrumManual")>0 && !is_ios()){
       if(!C11N.is_portal) wifi_spectrum.goBackToTwoViews();
      }
      else {
       if(!C11N.is_portal) wifi_spectrum.goBackToOneView();
      }
      if(!C11N.is_portal) wifi_spectrum.goBackToOneView();
      else H2GDIALOG.show_portal_results_screen(); // TODO : this should be removed as global from portal
      applyFix("",opt_results.test,opt_results.test_id,opt_results.fix,res_json||"",WTG.fmt($rootScope.strings.id_switch_channel_busy,{"channel":res_json[band] && res_json[band].suggested}));
     },
     cb_two: function(){
      L.trace("fix dialog ctrl - NO");
     }
    });
    return;
   }
  }
  else{
   if(routering_res && routering_res.res_data.type){
    error_msg = (routering_res.result == "prog") ? $rootScope.strings.wifi_help_router_test_progress : $rootScope.strings.wifi_help_router_not_configured;
   }else{
    error_msg = $rootScope.strings.wifi_help_unknown_router;
   }
  }
  WTGDIALOG.open_simple_dialog(WTGDIALOG.gen_popup,{header: $rootScope.strings.alert, body: error_msg , btn_one: $rootScope.strings.ok_btn});
 }
};
return wifi_spectrum;
})
.factory('spectrumData', function() {
 var wifiResults = {};
 function set(data) {
  wifiResults = data;
 }
 function get() {
  return wifiResults;
 }
 return {
  set: set,
  get: get
 };
})
.directive('wtgWifiSpectrum', function(WTGSPECTRUM) {
 return {
  restrict: 'E',
  templateUrl: WTGSPECTRUM.root_path+'wifi-spectrum.html',
  controller:'wifiOptimizerCtrl'
 };
})
.directive('wtgWifiSpectrumHelp', function(WTGSPECTRUM) {
 return {
  restrict: 'E',
  templateUrl: WTGSPECTRUM.root_path+'wifi-spectrum-help.html',
  controller:'WifiSpectrumHelpCtrl'
 };
})
.directive('wtgWifiSpectrumManual', function(WTGSPECTRUM) {
 return {
  restrict: 'E',
  templateUrl: WTGSPECTRUM.root_path+'wifi-spectrum-manual-selection.html' ,
  controller:'WifiSpectrumManualScreenCtrl'
 };
})
.controller('wifiOptimizerCtrlGraph', function($scope, $rootScope,TESTRESULTS,WTGSPECTRUM,spectrumData) {
 ['50','24'].forEach(function(b) {
  var b1 = b[0];
  WTGSPECTRUM.fitCanvasToContainer(b1+"ghzgraph");
  var wifi_data = $scope.history_show ? spectrumData.get() : TESTRESULTS.getWifiOptimizerTestResults();
  $scope.wifiResults = wifi_data && wifi_data.res_data;
  $scope.wc_desc = wifi_data.details;
  //L.trace("$scope.wifiResults--"+JSON.stringify($scope.wifiResults));
  if(!Object.keys($scope.wifiResults).length) return $scope.result_found = false;
  var wlist = prepareWifiScanResultsList($scope.wifiResults,b);
  $scope["colors"+b] = ['#45b7cd', '#ff6384', '#ff8e72',"#808080","#eb7676","#6ba563"];
  $scope["labels"+b] = wlist.labels;
  $scope["datasetOverride"+b] = wlist.dataset;
  $scope["data"+b] = wlist.data;
  $scope["options"+b] = wlist.options;
 });
 function prepareWifiScanResultsList(wifi_scan_res,bType){
  var sChannel = wifi_scan_res.channel && wifi_scan_res.channel.suggested;
  var cChannel = wifi_scan_res.channel && wifi_scan_res.channel.current;
  L.trace(sChannel +"--"+cChannel);
  var wifi_list = wifi_scan_res.bands[bType];
  var channels = [];
  var temp = {};
  var occupancy = [];
  for(var ch in wifi_list){
   channels.push(ch);
   occupancy.push(WTGSPECTRUM.getRSSIFromRSS(wifi_list[ch].o));
  }
  var dataArray = [];
  var dataset = [];
  var stemp = channels.map(function(x){ return (x==sChannel || x==cChannel) ? wifi_scan_res.connected_rssi : null});
  var cTemp = channels.map(function(x){ return ((x==sChannel || (x==cChannel && !sChannel)) ? 'rgba(0, 255, 0,1)' : (x==cChannel)? 'rgba(255, 0, 0,1)' : undefined)});
  dataArray.push(stemp);
  dataset = [
   {
    borderWidth: 0,
    type: 'bar',
    barThickness:100,
    backgroundColor: cTemp
   },
   {
    borderWidth: 1,
    type: 'line',
    spanGaps:true,
    backgroundColor : 'rgba(0,191,255,0.8)',
    borderColor : 'rgba(50,153,247,1)'
   }
  ];
  if(occupancy.length)dataArray.push(occupancy);
  temp.dataset = dataset;
  if(Object.keys(wifi_list).length){
   if(bType == "50") temp.labels = channels.map(function(x){ return (x==sChannel||x==cChannel||x==36||x==165)?x:""});
   else temp.labels = channels;
   temp.data = dataArray;
  }else{
   if(bType == "50"){
    temp.labels = [36,44,52,60,100,108,116,124,132,140,149,157,165];
    temp.data = [ [ {x: 36, y: null},{x: 165, y: null} ]];
   }else{
    temp.labels = channels;
    temp.data = [[ {x: 1, y: null},{x: 14, y: null} ]];
   }
  }
  temp.options = {
   title:{
    display:true,
    text: (bType == "24") ? $rootScope.strings.wifi_channel_graph_header_24ghz : $rootScope.strings.wifi_channel_graph_header_5ghz
   },
   scales: {
    yAxes: [{
     ticks: {
      beginAtZero:true
     },
     display :false
    }]
   },
   tooltips: {
    enabled: false
   }
  };
  return temp;
 }
}, false)
.controller('wifiOptimizerCtrlSignalGraph', function($scope, $rootScope,TESTRESULTS,WTGSPECTRUM,spectrumData) {
 L.trace("signal_graph_controller");
 /* TODO: I have no idea what it is meant to be, but with undefined b1, which
  * is supposedly either 5 or 2 it probably won't work
 WTGSPECTRUM.fitCanvasToContainer(b1+"ghzgraph");
  */
 var wifi_data = $scope.history_show ? spectrumData.get() : TESTRESULTS.getWifiOptimizerTestResults();
 $scope.wifiResults = wifi_data && wifi_data.res_data;
 if(!$scope.wifiResults || !$scope.wifiResults.bands) return $scope.result_found = false;
 var wifi_scan_res = $scope.wifiResults;
 var sChannel = wifi_scan_res.channel && wifi_scan_res.channel.suggested;
 var cChannel = wifi_scan_res.channel && wifi_scan_res.channel.current;
 var c_type = (cChannel >0) && ((cChannel >14) ? "50" : "24");
 var connected_dbm = 0;
 L.trace(sChannel +"--"+cChannel);
 var wifi_list = wifi_scan_res.bands[c_type];
 var nl = wifi_list && wifi_list[cChannel] && wifi_list[cChannel].n;
 for(var n in nl){
  if(nl[n].c){
   connected_dbm = nl[n].rss;
   break;
  }
 }
 L.trace("connected_dbm-->"+connected_dbm);
 var channels = [];
 var occupancy = [];

 for(var ch in wifi_list){
  channels.push(ch);
  var signal_strength = connected_dbm - wifi_list[ch].o;
  //TO DO - if dbm difference is zero then we are adding one  point for showing bar at that place
  if(signal_strength == 0) signal_strength++;
  occupancy.push(signal_strength);
  L.trace("signal_strength-->"+signal_strength);
 }
 $scope.data = [];
 $scope.colors = ['#45b7cd', '#ff6384', '#ff8e72',"#808080","#eb7676","#6ba563"];
 $scope.data.push(occupancy);
 var cTemp = channels.map(function(x){return ((x==sChannel || (x==cChannel && !sChannel)) ? 'rgba(60,184,77,1)' : (x==cChannel)? 'rgba(255, 0, 0,1)' : 'rgba(94, 136, 123,1)')});
 $scope.datasetOverride = [
  {
   borderWidth: 0,
   type: 'bar',
   barThickness:100,
   backgroundColor: cTemp
  }
 ];
 if(c_type == "50"){
  //$scope.labels =  channels.map(function(x){ return (x==sChannel||x==cChannel||x==36||x==165)?x:""});
  $scope.labels = [36,"",44,"",52,"",60,"",100,"",108,"",116,"",124,"",132,"",140,"",149 ];
 }
 else $scope.labels = channels;
 var max_num = Math.max.apply(Math, occupancy);
 var min_num = Math.min.apply(Math, occupancy);
 var fSize = parseInt($(".signal_canvas_area").css('font-size').slice(0, -2));
 if(!fSize){
  var w = $(document.body).innerWidth() || getScreenWidth();
  fSize = (w > 500) ? ((w*12)/500) : 12 ;
 }
 L.trace("screen fontSize ---"+ fSize);
 $scope.options = {
  title:{
   display:true,
   text: (c_type == "24") ? $rootScope.strings.wifi_channel_graph_header_24ghz : $rootScope.strings.wifi_channel_graph_header_5ghz,
   fontColor: '#FFFFFF',
   fontSize :fSize,
   fontStyle: "bold"
  },
  scales: {
   yAxes: [{
    scaleLabel: {
     display: true,
     fontColor: '#FFFFFF',
     fontSize :fSize,
     fontStyle: "bold",
     labelString: $rootScope.strings.wifi_channel_graph_yaxis_label
    },
    ticks:{
     fixedStepSize: (max_num == min_num) ? 10 : "",
     fontSize :fSize+2,
     callback: function (value) {
      if(max_num == min_num)
      return (value > max_num) ? $rootScope.strings.wifi_channel_graph_yaxis_label_high : ((value < min_num) ? $rootScope.strings.wifi_channel_graph_yaxis_label_low : "");
      return (value >= max_num) ? $rootScope.strings.wifi_channel_graph_yaxis_label_high : ((value <= min_num) ? $rootScope.strings.wifi_channel_graph_yaxis_label_low : "");
     }
    }
   }],
   xAxes: [{
    scaleLabel: {
     display: true,
     fontColor: '#FFFFFF',
     fontSize :fSize,
     fontStyle: "bold",
     labelString:  $rootScope.strings.wifi_channel_graph_xaxis_label
    },
    ticks:{
     fontSize :fSize
    },
    barThickness:fSize/2
   }]
  },
  tooltips: {
   enabled: false
  },

 };
}, false)
.controller('wifiOptimizerCtrl', function($scope, $rootScope,TESTRESULTS,WTGSPECTRUM,spectrumData) {
 $scope.networkSSID = $rootScope.strings.network_list_ssid;
 $scope.networkBSSID = $rootScope.strings.network_list_bssid;
 $scope.signal = $rootScope.strings.network_list_header_signal;
 $scope.networkChannel = $rootScope.strings.wifi_network_list_channel;
 $scope.channelBand = $rootScope.strings.wifi_network_list_band;
 $scope.channelWidth = $rootScope.strings.network_list_header_channel_width; // "Channel Width (MHz)" ;
 $scope.result_found = true;
 $scope.str_no_data = $rootScope.strings.no_data_available;
 $scope.str_graph = $rootScope.strings.wifi_channel_tab_graph;
 $scope.str_networks = $rootScope.strings.wifi_channel_tab_networks;
 var sepctrum_data = spectrumData.get();
 $scope.history_show = sepctrum_data && sepctrum_data.history;
 console.log("$scope.history_show--"+$scope.history_show);
 $scope.graphical_view = true;
 $scope.recommended_channel = $rootScope.strings.wifi_spectrum_txt_recommended_channel;
 $scope.other_channels = $rootScope.strings.wifi_spectrum_txt_other_channels;
 $scope.signal_to_noise_ratio = $rootScope.strings.wifi_channel_graph_subheader;
 $scope.barclr = "#ff0000";
 $scope.wifiResults = {};
 if($scope.history_show) $("#ws_graphical_view").css("height","90%");
 var opt_results = TESTRESULTS.getWifiOptimizerTestResults();
 var wifi_scan_res = opt_results && opt_results.res_data || "";
 if(!wifi_scan_res || !wifi_scan_res.bands){
  L.error("wifiChannelCtrl-error-no data found");
  $scope.result_found = false;
  return;
 }
 $scope.wifi_ssid_list = [];
 $scope.is_valid_router = function is_valid_router() {
  var rout_res = TESTRESULTS.getRouteringTestResults();
  return (rout_res && rout_res.res_data && rout_res.res_data.type) ;
 };
 var sChannel = wifi_scan_res.channel && wifi_scan_res.channel.suggested;
 var cChannel = wifi_scan_res.channel && wifi_scan_res.channel.current;
 var band = (cChannel >0) && ((cChannel >14) ? "50" : "24");
 $scope.manual_btn_show = (cChannel && sChannel) ? true : false;
 $scope.barclr = (cChannel == sChannel) ? "#3CB84D" : "#ff0000" ;
 $scope.switch_Btn = $rootScope.strings.wifi_channel_switch_now;
 $scope.sChannel = sChannel;
 $scope.cChannel = cChannel;
 $scope.band = band;
 if((cChannel == sChannel)|| !cChannel || !sChannel){
  $scope.dismiss_Btn = $rootScope.strings.wifi_spectrum_good_btn_ok;
  $scope.btn_show = false;
  $scope.sg_switch_other_channel = $rootScope.strings.wifi_spectrum_good_btn_manual;
 }else{
  $scope.btn_show = true;
  $scope.dismiss_Btn =$rootScope.strings.wifi_channel_dismiss;
  $scope.sg_switch_Btn =$rootScope.strings.wifi_spectrum_not_good_btn_fix;
  $scope.sg_switch_other_channel = $rootScope.strings.wifi_spectrum_not_good_btn_manual;
 }
 var c_type = (cChannel >14) ? " 5 Ghz" : ((cChannel >0) ? " 2.4 Ghz" : "") ;
 $scope.current_channel = WTG.fmt($rootScope.strings.wifi_spectrum_txt_curr_channel,{"channel":cChannel,"band":c_type});
 $scope.is_valid = $scope.is_valid_router();
 $scope.$on('$ionicView.enter', function(){
  setStatusBarColor('main_ui');
  //TODO : Need to remove this global
  H2GAPP.setTitle(false,$rootScope.strings.wifi_channel_header_title);
  sendAnalyticsInfo({id:software_use_events.wifi_optimizer});
 });
 $scope.onShowGraphicalView = function (){
  L.trace("onShowGraphicalView--");
  $scope.graphical_view = true;
  $("#ws_graph_tab").css("color","#FFFFFF");
  $("#ws_network_tab").css("color","#000000");
 };
 $scope.onShowTableView = function (){
  L.trace("onShowTableView--");
  $scope.graphical_view = false;
  $("#ws_network_tab").css("color","#FFFFFF");
  $("#ws_graph_tab").css("color","#000000");
  $scope.wifi_ssid_list = $scope.getWiFiListFromWiFiScanTestResult();
 };
 $scope.onClickFixButton = function(){
  var res_json = {};
  res_json[$scope.band] = {"current":$scope.cChannel,"suggested":$scope.sChannel};
  L.trace("onClickFixButton--"+JSON.stringify(res_json));
  WTGSPECTRUM.validateRouter($rootScope,res_json);
 };
 $scope.onClickDismissBtn = function(){
  L.trace("onClickDismissBtn");
  backButtonEvent();
 };
 $scope.onOpenWifiHelpScreen = function(){
  L.trace("onOpenWifiHelpScreen");
  WTGSPECTRUM.validateRouter($rootScope,"",true);
 };
 $scope.getSignal = function(rss){
  return Math.ceil(WTGSPECTRUM.getRSSIFromRSS(rss));
 };
 $scope.getWidth = function(selector1,selector2){
  var width = _portrait ? "100%" : ((selector1 && selector2) ? "33%" : "50%") ;
  return $scope.myObj = {
   "width" : width
  };
 };
 $scope.refresh_screen = function(/*rss*/){
  $scope.is_valid = $scope.is_valid_router();
 };
 $scope.getWiFiListFromWiFiScanTestResult = function getWiFiListFromWiFiScanTestResult() {
  var t = TUTIL.get_test_result_data("wifi",'wifi_optimizer');
  var bb = t && t.bands;
  if(!bb) return undefined;
  var rv = [];
  for(var b in bb) { var B = bb[b];
   for(var c in B) { var C = B[c];
    if(!(C && C.n && C.n.forEach)) continue;
    C.n.forEach(function(n) {
     rv.push({ SSID: n.ssid, BSSID: n.bssid, channel: c, signal:n.rss, cWidth:n.channelWidth});
    });
   }
  }
  return rv;
 };
}, false)
.controller('WifiSpectrumManualScreenCtrl', function($scope, $rootScope,WTGSPECTRUM) {
 function loadManualSwitchData() {
  var band24_data ,band50_data, channel_array24,channel_array50,cChannel_24,cChannel_50;
  var router_test_data = getRouteringTestResults();
  if(router_test_data.res_data && router_test_data.res_data.channels){
   band24_data = router_test_data.res_data.channels.band24;
   band50_data = router_test_data.res_data.channels.band50;
   channel_array24 = band24_data && band24_data.supported && band24_data.supported.split(",") || "";
   channel_array50 = band50_data && band50_data.supported && band50_data.supported.split(",") || "";
   cChannel_24 = band24_data && band24_data.current || "";
   cChannel_50 =band50_data && band50_data.current || "";
  }else{
   L.error("routering test data not available");
  }
  $scope.bands = [
   { str:"2.4 Ghz", value : 24, show : !!channel_array24},
   { str:"5 Ghz" , value : 50, show : !!channel_array50 }
  ];
  $scope.band_index = 0;
  $scope.Suggested_channel_24 = channel_array24;
  $scope.Suggested_channel_50 = channel_array50;
  $scope.cChannel_24 = cChannel_24;
  $scope.cChannel_50 = cChannel_50;
  $scope.channel_data = $scope.band_index ? $scope.Suggested_channel_50 : $scope.Suggested_channel_24;
  $scope.cChannel = $scope.band_index ? $scope.cChannel_50 : $scope.cChannel_24;
  $scope.channel_index = $scope.channel_data.indexOf($scope.cChannel.toString());
  $scope.disable_switch = true;
 }
 $scope.$on('$ionicView.enter', function(){
  $scope.tdc=false;
  loadManualSwitchData();
  //TODO : Need to remove this global
  H2GAPP.setTitle(false,$rootScope.strings.wifi_spectrum_btn_switch_channel);
 });
 if(C11N.is_portal) loadManualSwitchData();
 $scope.str_wifi_manual_switch_desc = $rootScope.strings.wifi_manual_switch_desc;
 $scope.str_wifi_manual_switch_title = $rootScope.strings.wifi_manual_switch_title;
 $scope.str_wifi_channel_selection_dd_label_band = $rootScope.strings.wifi_channel_selection_dd_label_band;
 $scope.str_wifi_channel_selection_dd_label_channel = $rootScope.strings.wifi_channel_selection_dd_label_channel;
 $scope.wifi_help_switch_channel = $rootScope.strings.wifi_spectrum_btn_switch_channel;
 $scope.OnClickMoreHelp = function(){
  //setTimeout(function() { request_custom_action("OPEN_CONTACT_VIEW",""); }, 0);
 };
 $scope.OnClickSwitchChannel = function(band,sc){
  var res_json = {};
  res_json[band] = {"current":$scope.cChannel,"suggested":sc};
  //L.trace("OnClickSwitchChannel--"+JSON.stringify(res_json));
  WTGSPECTRUM.validateRouter($rootScope,res_json);
 };
 $scope.onChangeChannel = function(band,sc){
  L.trace("onChangeChannel--"+band+"---"+sc);
  $scope.channel_data = band == "24" ? $scope.Suggested_channel_24 : $scope.Suggested_channel_50;
  $scope.cChannel = band == "24" ? $scope.cChannel_24 : $scope.cChannel_50 ;
  $scope.channel_index = $scope.channel_data && $scope.channel_data.indexOf($scope.cChannel.toString());
  if( sc != $scope.cChannel) $scope.disable_switch = false;
  else $scope.disable_switch = true;
 };
}, false)
.controller('WifiSpectrumHelpCtrl', function($scope, $rootScope,WTGSPECTRUM) {
 $scope.$on('$ionicView.enter', function(){
  //TODO : Need to remove this global
  H2GAPP.setTitle(false,$rootScope.strings.wifi_spectrum_btn_get_tip);
 });
 $scope.ins_header = $rootScope.strings.wifi_spectrum_btn_get_tip_desc_header;
 $scope.instructions = [$rootScope.strings.wifi_spectrum_btn_get_tip_desc_ins_one,$rootScope.strings.wifi_spectrum_btn_get_tip_desc_ins_two,$rootScope.strings.wifi_spectrum_btn_get_tip_desc_ins_three,$rootScope.strings.wifi_spectrum_btn_get_tip_desc_ins_four];
 $scope.dismiss_Btn =$rootScope.strings.id_btn_finish;
 $scope.sg_switch_Btn =$rootScope.strings.wifi_spectrum_btn_switch_channel;
 $scope.okBtn = $rootScope.strings.ok_btn;
 $scope.helpIcon = WTG.img("help.svg");
 $scope.tdc=false;
 $scope.body = "Container text"; // Hard coded text
 $scope.onClickDismissBtn = function(){
  L.trace("onClickDismissBtn");
  if(!C11N.is_portal) backButtonEvent();
 };
 $scope.onOpenWifiManualSelectionScreen = function(){
  L.trace("onOpenWifiManualSelectionScreen");
  WTGSPECTRUM.validateRouter($rootScope,"",true);
 };
}, false);

export var SPECTRUM = {
 perform_wifi_test:null,
 showManualSelectionPage:null,
 refresh_screen : function refresh_screen(test){
  var $scope = angular.element($('#wifi_spectrum_screen')).scope();
  if(!$scope) return;
  L.trace("refresh_screen--"+test);
  $scope.$apply($scope.is_valid_router);
 }
};
/* vim:set ts=8 sw=1 expandtab: */
